import React, { ReactElement } from "react";
import { Heading, RadioGroup } from "@telia/teddy";
import cn from "classnames";
import "./RadioButtonCard.less";

export interface Option {
    description?: ReactElement;
    heading: string;
    headingIcon?: ReactElement;
    isDisabled?: boolean;
    value: string;
}

interface Props {
    buttonGroupId?: string;
    options: Option[];
    selectedValue?: string;
    setSelectedValue: (value: string) => void;
    children?: React.ReactNode;
}

const RadioButtonCards: React.FC<Props> = ({ selectedValue, setSelectedValue, options, buttonGroupId, children }) => {
    return (
        <div className="radio-button-cards">
            <RadioGroup value={selectedValue || ""} onValueChange={setSelectedValue} name={buttonGroupId || undefined}>
                {options.map(({ value, heading, headingIcon, description, isDisabled = false }) => {
                    const isSelected = selectedValue === value;
                    return (
                        <React.Fragment key={value}>
                            <RadioGroup.Item
                                className={cn("radio-button-cards__card", {
                                    "radio-button-cards__card--selected": isSelected,
                                    "radio-button-cards__card--disabled": isDisabled,
                                })}
                                onClick={() => {
                                    if (!isDisabled) {
                                        setSelectedValue(value);
                                    }
                                }}
                            >
                                <RadioGroup.Trigger value={value} disabled={isDisabled} />
                                <div className="radio-button-cards__heading-row">
                                    <Heading
                                        mb="100"
                                        as="h3"
                                        variant="title-100"
                                        className="radio-button-cards__card-heading"
                                    >
                                        <RadioGroup.Label>{heading}</RadioGroup.Label>
                                    </Heading>
                                    {headingIcon && (
                                        <div className="radio-button-cards__card-heading-icon">{headingIcon}</div>
                                    )}
                                </div>
                                {description && (
                                    <div className="radio-button-cards__card-description">{description}</div>
                                )}
                            </RadioGroup.Item>
                            {isSelected && children}
                        </React.Fragment>
                    );
                })}
            </RadioGroup>
        </div>
    );
};

export default RadioButtonCards;
